import { Suspense, ReactElement } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { IEndFlowManager } from '../../services/endflowmanager/EndFlowManager'

export const Routing = ({
    children,
}: {
    children: ReactElement
    locizeOptions?: {
        projectId: string
        apiKey: string
        version: string
        referenceLng: string
    }
    endFlowManager?: IEndFlowManager
}): ReactElement => {
    return (
        <BrowserRouter>
            <Routes>
                {[
                    '/',
                    '/:flow',
                    '/:flow/:bookingId',
                    '/adminbook',
                    '/adminbook/:flow/:bookingId',
                ].map((path) => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <Suspense fallback={<>Loading...</>}>
                                {children}
                            </Suspense>
                        }
                    />
                ))}
            </Routes>
        </BrowserRouter>
    )
}
